import * as Yup from "yup";

export default Yup.object().shape({
    name: Yup.string().required("Please enter a Sales Tool name"),
    availableOn: Yup.date().required("Available On is required")
});